import { render, staticRenderFns } from "./ObservatoryLayer.vue?vue&type=template&id=4a7457dc&"
import script from "./ObservatoryLayer.vue?vue&type=script&lang=js&"
export * from "./ObservatoryLayer.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryLayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports